import { uiActions } from '@/store/slices/uiSlice';

export const toast = {
  success(message: string) {
    return uiActions.pushToast({ message: message.slice(0, 256), variant: 'success' });
  },
  error(message: string) {
    return uiActions.pushToast({ message: message.slice(0, 256), variant: 'error' });
  },
  info(message: string) {
    return uiActions.pushToast({ message: message.slice(0, 256), variant: 'info' });
  },
};
